module.exports = __webpack_public_path__ + "img/tel-ft.a35a71e7.png";